import React, { useEffect } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Elements } from 'react-stripe-elements';
import PropTypes from 'prop-types';
import { ReactComponent as FolderIcon } from './../addPortfolioToInvitePopup/assets/folder-icon.svg';
import { ReactComponent as LinkIcon } from './../addPortfolioToInvitePopup/assets/link-icon.svg';
import { ReactComponent as UploadIcon } from './../addPortfolioToInvitePopup/assets/upload-icon.svg';
import './ReviewerPortfolioPopup.css';
import Link from '../addPortfolioToInvitePopup/portfolioLinks/link/Link';
import DownloadFile from './downloadFile/DownloadFile';

const ReviewerPortfolioPopup = ({ isOpen, handleToggle, portfolio, clearPortfolio }) => {
    useEffect(() => {
        return () => clearPortfolio();
    }, [clearPortfolio]);

    return (
        <div>
            <Modal isOpen={isOpen} toggle={handleToggle} className="addPortfolioPopup">
                <ModalHeader className="add-portfolio-header" toggle={handleToggle}>
                    User portfolio
                </ModalHeader>
                <ModalBody>
                    <Elements>
                        <div className="form-wrap">
                            <div className="modal-field">
                                <div className="field-wrap">
                                    <div className="field-header">
                                        <UploadIcon />
                                        <div className="header-text">User Media</div>
                                    </div>
                                    <ul className="portfolio-files-wrap">
                                        {portfolio.files.map(file => (
                                            <DownloadFile key={file.path} file={file} />
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            <div className="modal-field">
                                <div className="field-wrap">
                                    <div className="field-header">
                                        <LinkIcon />
                                        <div className="header-text">User Portfolio Links</div>
                                    </div>
                                    <ul className="portfolio-links-wrapper">
                                        {portfolio.portfolioLinks.map((link, i) => (
                                            <Link
                                                key={link.link}
                                                link={link}
                                                i={i}
                                                errors={{}}
                                                touched={{}}
                                                name="portfolio-link"
                                                readOnly
                                            />
                                        ))}
                                    </ul>
                                </div>
                            </div>

                            <div className="modal-field">
                                <div className="field-wrap">
                                    <div className="field-header">
                                        <FolderIcon />
                                        <div className="header-text">Cover letter</div>
                                    </div>
                                    <div className="formFieldWrapper comment-wrap">
                                        {portfolio.comment}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Elements>
                </ModalBody>
            </Modal>
        </div>
    );
};

ReviewerPortfolioPopup.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    handleToggle: PropTypes.func.isRequired,
    portfolio: PropTypes.any.isRequired,
    clearPortfolio: PropTypes.func.isRequired,
};

export default ReviewerPortfolioPopup;
